"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TITLE_PLACEHOLDER = exports.expanderThemeArray = exports.ExpanderTheme = void 0;
var ExpanderTheme;
exports.ExpanderTheme = ExpanderTheme;

(function (ExpanderTheme) {
  ExpanderTheme["WHITE"] = "white";
  ExpanderTheme["SEASHELL"] = "seashell";
  ExpanderTheme["SEASHELL_ALT"] = "seashell-alt";
  ExpanderTheme["MOCASSIN"] = "mocassin";
  ExpanderTheme["MOCASSIN_ALT"] = "mocassin-alt";
  ExpanderTheme["CLARET"] = "claret";
  ExpanderTheme["CLARET_ALT"] = "claret-alt";
  ExpanderTheme["BLACK"] = "black";
  ExpanderTheme["BLACK_ALT"] = "black-alt";
})(ExpanderTheme || (exports.ExpanderTheme = ExpanderTheme = {}));

var expanderThemeArray = Object.values(ExpanderTheme);
exports.expanderThemeArray = expanderThemeArray;
var TITLE_PLACEHOLDER = 'Add Expander section name';
exports.TITLE_PLACEHOLDER = TITLE_PLACEHOLDER;